<template>
		<div class="nodata-wrapper" id="nodata">
			<img :src="nodata.imgpath" alt="">
			<p class="nodata-text">{{nodata.text}}</p>
			<p class="nodata-aux">{{nodata.aux}}</p>
			<p name="btn"><slot name="btn"></slot></p>
		</div>
</template>

<script>
	export default {
		name:'Nodata',
		props:{
			nodata:Object
		}
	}
</script>

<style scoped>
	.nodata-wrapper{
		padding-top: 200px;
		text-align: center;
	}
	.nodata-wrapper img{
		display: block;
		margin: auto;
		width: 240px;
		height: auto;
	}
	.nodata-text{
		font-size: 28px;
		margin-top: 40px;
	}
	.nodata-aux{
		font-size: 24px;
		color: #999;
		margin-top:12px;
	}
	.btn-tocourse{
		display: inline-block;
		padding: 0 28px;
		line-height: 64px;
		border-radius: 60px;
		background-color: #fe5252;
		color: #fff;
		font-size: 24px;
		margin-top: 24px;
	}
</style>
